import { connect } from "react-redux";
import ViewEmployeeTicket from "./viewEmployeeTicket";
import { bindActionCreators } from "redux";
import { postTicketAssignment } from "services/redux/maintenance/rmTicket/action";
import {
  fetchEmTicketDetails,
  postUpdateEMStatus,
  postEmployeeRemark,
  fetchEmTicketStatus,
} from "services/redux/maintenance/employeeTickets/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  pmTicket: state.pmTicketReducer.pmTicket,
  employeeTicketDetails: state.employeeTicketReducer.employeeTicketDetails,
  employeeStatus: state.employeeTicketReducer.employeeStatus,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postUpdateEMStatus,
      documentUploadUrl,
      postEmployeeRemark,
      fetchEmTicketStatus,
      postTicketAssignment,
      fetchEmTicketDetails,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmployeeTicket);
